import { PropsWithChildren } from 'react'

import { JourneyContextProps } from '@cash-web/shared-journey-data-access-context'
import { JourneyData } from '@cash-web/shared-journey-util-main'

import { JourneyOutletContext } from './JourneyOutletContext'
import { JourneyTargetRenderer } from './JourneyTargetRenderer'

export type JourneyPaneRendererProps = {
  history: JourneyData[]
  onBack?: JourneyContextProps['cancel']
  onClose: JourneyContextProps['cancelAll']
}

export const JourneyPaneRenderer = ({ children, ...props }: PropsWithChildren<JourneyPaneRendererProps>) => {
  return (
    <JourneyOutletContext.Provider value={props}>
      {children}
      <JourneyTargetRenderer target="modal" {...props} />
      <JourneyTargetRenderer target="fullscreen" {...props} />
    </JourneyOutletContext.Provider>
  )
}
